import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f3804312"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "serial" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "trilateral" }, [
  /*#__PURE__*/_createElementVNode("span")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_popover = _resolveComponent("van-popover")!

  return (_openBlock(), _createBlock(_component_van_popover, {
    show: $setup.showPopover,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($setup.showPopover) = $event)),
    actions: $setup.actions,
    onSelect: $setup.onSelect,
    class: "drop-down"
  }, {
    reference: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, " +" + _toDisplayString($setup.prefix), 1),
        _hoisted_2
      ])
    ]),
    _: 1
  }, 8, ["show", "actions", "onSelect"]))
}